import GenericIdValue from "./GenericIdValue";
import TypeValue from "./TypeValue";
import {keys} from "../config/nameSpacesKeys";
import {assetKeys} from "../config/constants";


export default class SoftwareDistribution {
  constructor(name, initialValue, namespace,
      downloadLocationNameSpace, accessLocationNameSpace, executionLocationNameSpace,
      softwareDistributionFormNameSpace, isEditor) {
    this.namespace = namespace;
    this.name = name;
    this.isEditor = isEditor;
    this.downloadLocationNameSpace = downloadLocationNameSpace;
    this.accessLocationNameSpace = accessLocationNameSpace;
    this.executionLocationNameSpace = executionLocationNameSpace;
    this.softwareDistributionFormNameSpace = softwareDistributionFormNameSpace;
    this.downloadLocation = new TypeValue("downloadLocation", null, downloadLocationNameSpace, keys.uriType);
    this.accessLocation = new TypeValue("accessLocation", null, accessLocationNameSpace, keys.uriType);
    this.executionLocation = new TypeValue("executionLocation", null, executionLocationNameSpace, keys.uriType);
    this.softwareDistributionForm = new GenericIdValue("softwareDistributionForm", null, softwareDistributionFormNameSpace);
    if (initialValue) {
      this.parseInputJSON(initialValue);
    }
  }

  getNameSpace() {
    return this.namespace;
  }

  getdownloadLocationObj() {
    return this.downloadLocation;
  }
  setdownloadLocationObj(downloadLocationObj) {
    this.downloadLocation = downloadLocationObj;
  }
  getaccessLocationObj() {
    return this.accessLocation;
  }
  setaccessLocationObj(accessLocationObj) {
    this.accessLocation = accessLocationObj;
  }

  getExecutionLocation() {
    return this.executionLocation;
  }

  setExecutionLocation(executionLocationObj) {
    this.executionLocation = executionLocationObj;
  }

  getSoftwareDistributionForm() {
    return this.softwareDistributionForm;
  }

  setSoftwareDistributionForm(softwareDistributionFormObj) {
    this.softwareDistributionForm = softwareDistributionFormObj;
  }

  setValueObj(obj) {
    // console.log(obj);
    this.downloadLocation.parseInputJSON(obj);
    this.accessLocation.parseInputJSON(obj);
    this.executionLocation.parseInputJSON(obj);
    this.softwareDistributionForm.parseInputJSON(obj);
  }

  parseInputJSON(inputJSON) {
    const obj = inputJSON[this.namespace];
    // console.log(obj, this.namespace);
    if (Array.isArray(obj)) {
      for (const entry of Object.entries(obj)) {
        const value = entry[1];
        this.setValueObj(value);
      }
    } else {
      this.setValueObj(obj);
    }
  }

  getExpandedFormatValue() {
    const obj = {};
    const accesUrlExpanded = this.accessLocation.getExpandedFormatValue();
    const downloadLocationExpanded = this.downloadLocation.getExpandedFormatValue();
    const executionLocationExpanded = this.executionLocation.getExpandedFormatValue();
    const softwareDistributionFormExpanded = this.softwareDistributionForm.getExpandedFormatValue();

    obj[assetKeys.type] = [`${keys.softwareDistribution}`];
    obj[this.accessLocation.getNameSpace()] = accesUrlExpanded;
    obj[this.downloadLocation.getNameSpace()] = downloadLocationExpanded;
    obj[this.executionLocation.getNameSpace()] = executionLocationExpanded;
    obj[this.softwareDistributionForm.getNameSpace()] = softwareDistributionFormExpanded;
    return obj;
  }

  isEmpty() {
    const condition1 = this.accessLocation.isEmpty() && this.downloadLocation.isEmpty() && this.executionLocation.isEmpty();
    const condition2 = this.softwareDistributionForm.isEmpty();
    return condition1 && condition2;
  }
}
